import './Content.scss';

import cn from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { ContentDefaultProps, ContentPropTypes } from './Content.proptypes';
import useContent from './useContent';

const Content = ({ className, order }) => {
  const { t, i18n } = useTranslation();

  const { getItemType } = useContent();

  return (
    <div className={cn('scanbat-checkout-confirm-content', className)}>
      <div className="scanbat-checkout-confirm-content__infos infos">
        <p className="infos__title">
          {t('ebat:entities:scanbat.checkout_confirm.infos', {
            number: `${order.number}`,
          })}
        </p>
        <ul className="infos__list">
          <li className="infos__item">
            <span className="infos__label">
              {t('ebat:entities:orders.label.date')}
            </span>
            <span className="infos__value">
              {i18n.format(order.created_at, 'short')}
            </span>
          </li>
          <li className="infos__item">
            <span className="infos__label">
              {t('ebat:entities:orders.label.reference')}
            </span>
            <span className="infos__value">{order.reference || '--'}</span>
          </li>
          <li className="infos__item">
            <span className="infos__label">
              {t('ebat:entities:orders.label.status')}
            </span>
            <span className="infos__value">{order.status?.label || '--'}</span>
          </li>
          <li className="infos__item">
            <span className="infos__label">
              {t('ebat:entities:orders.label.store')}
            </span>
            <span className="infos__value">
              {order.shipping_store?.name || '--'}
            </span>
          </li>
          <li className="infos__item">
            <span className="infos__label">
              {t('ebat:entities:orders.label.worksite')}
            </span>
            <span className="infos__value edit-worksite">
              {order.worksite?.label || order.worksite?.code || '--'}
            </span>
          </li>
        </ul>
      </div>
      {order.order_lines.length > 0 && (
        <ul className="scanbat-checkout-confirm-content__list">
          {order.order_lines.map((item) => (
            <li
              className="scanbat-checkout-confirm-content__item"
              key={`scanbat-order-item-${item.id}`}
            >
              {getItemType(item)}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

Content.defaultProps = {
  ...ContentDefaultProps,
};

Content.propTypes = {
  ...ContentPropTypes,
};

export default Content;
